export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9490.a68bde57.jpg";